export function isSubmitDisabled({
    oldPassword,
    newPassword,
    confirmNewPassword,
    validationFailures,
    isAdviser
}) {
    return (
        !oldPassword ||
        !newPassword ||
        !confirmNewPassword ||
        !!validationFailures.length ||
        isAdviser
    );
}
